import type { QuoteAlign, QuoteProps, QuoteStyle } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { ColorField, SelectField, TextField } from "./fields.js";
import { MediaField } from "./MediaField.js";
import type { WidgetInspectorProps } from "./registry.js";

const STYLE = ["classic", "modern", "card"] as const;
const ALIGN = ["left", "center"] as const;

export function QuoteInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as QuoteProps;

  return (
    <>
      <SelectField
        label="Style"
        value={p.style ?? "modern"}
        options={STYLE}
        onChange={(v) => update(widget.id, { style: v as QuoteStyle })}
      />
      <SelectField
        label="Align"
        value={p.align ?? "center"}
        options={ALIGN}
        onChange={(v) => update(widget.id, { align: v as QuoteAlign })}
      />
      <TextField
        label="Quote"
        value={p.quote}
        multiline
        onChange={(v) => update(widget.id, { quote: v })}
      />
      <TextField
        label="Author"
        value={p.author ?? ""}
        onChange={(v) => update(widget.id, { author: v || undefined })}
      />
      <TextField
        label="Source"
        value={p.source ?? ""}
        onChange={(v) => update(widget.id, { source: v || undefined })}
      />
      <MediaField
        label="Avatar URL"
        value={p.avatarUrl ?? ""}
        onChange={(v) => update(widget.id, { avatarUrl: v || undefined })}
      />
      <ColorField
        label="Accent"
        value={p.accent ?? "#111827"}
        onChange={(v) => update(widget.id, { accent: v })}
      />
      <ColorField
        label="Text"
        value={p.textColor ?? "#0f172a"}
        onChange={(v) => update(widget.id, { textColor: v })}
      />
    </>
  );
}
